var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtyVpnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4240_536)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.206055,
    y: 0.132935,
    width: 90.5173,
    height: 90.5173,
    rx: 33.2937,
    fill: "#4A98FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9659 45.0447C67.9659 57.0634 58.1501 66.8524 45.9848 66.8524C33.8195 66.8524 24.0037 57.0634 24.0037 45.0447C24.0037 33.026 33.8195 23.237 45.9848 23.237C58.1501 23.237 67.9659 33.026 67.9659 45.0447Z",
    stroke: "white",
    strokeWidth: 8.05919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4592,
    y: 40.3629,
    width: 27.0511,
    height: 29.132,
    rx: 13.5256,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4240_536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.5173,
    height: 90.5173,
    fill: "white",
    transform: "translate(0.412598 0.132935)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtyVpnLogo);
export default __webpack_public_path__ + "static/media/etyVpnLogo.74b4362bc7c8fb12a792745551cc748f.svg";
export { ForwardRef as ReactComponent };